import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    formStyleWrapper: {
      marginBottom: '16px',
      marginLeft: '16px',
      marginRight: '16px',
      // handle description input height
      '& textarea#description': {
        minHeight: '150px',
        maxHeight: '300px',
        resize: 'vertical',
        overflow: 'auto'
      },
      // handle hiding of relatedEntityCode button
      '& input#relatedEntityCode ~ .MuiAutocomplete-endAdornment': {
        display: 'none'
      },
      '& [class*="sectionHeader"] h6:empty': {
        display: 'none'
      },
      '& [class*="sectionHeader"] h6:empty + hr': {
        display: 'none'
      },
      '& [class*="collapsibleSectionHeader"]': {
        marginTop: '16px'
      },
      '& .MuiAccordion-root:before': {
        display: 'none'
      }
    }
  })
